import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

const useAcoesDemonstrativo = ({ formik: propsFormik }) => {
  const { values, setValues, setFieldValue } = propsFormik;

  const validaReferencia = (data) => {
    const regexData = /^(0[1-9]|1[0-2])\/\d{4}$/;

    if (regexData.test(data) === false) {
      return false;
    }
    return true;
  };

  const calculaData = () => {
    if (values.txReferencia !== null && validaReferencia(values.txReferencia)) {
      // converter string para data no formato mês/ano
      let dtReferencia = parse(values.txReferencia, "MM/yyyy", new Date(), { locale: ptBR });

      // converter data para formato dia/mês/ano
      dtReferencia = format(dtReferencia, "dd/MM/yyyy", { locale: ptBR });

      const partesData = dtReferencia.split("/");

      // Criar um objeto Date com a data no formato pt-BR (mês começa em 0, por isso -1 no mês)
      const dataVencimento = new Date(partesData[2], partesData[1] - 1, partesData[0]);

      // Adicionar o número de dias desejado à data
      dataVencimento.setDate(dataVencimento.getDate() + 14);

      let mes = dataVencimento.getMonth();

      mes += 1;

      dataVencimento.setMonth(mes);

      setValues((curr) => ({
        ...curr,
        dtVencimento: format(dataVencimento, "yyyy-MM-dd"), // conversão da data no formato americano para o componente DateTimeInputFormik
      }));
    } else {
      setValues((curr) => ({
        ...curr,
        dtVencimento: "",
      }));
    }
  };

  const calculaIcms = () => {
    let valorIcms = "";

    if (values.vlApurado !== undefined && values.vlDeclarado !== undefined) {
      valorIcms = values.vlApurado - values.vlIcmsRecolhido;
    }

    setValues((curr) => ({
      ...curr,
      vlIcms: valorIcms ?? valorIcms.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
      vlIcmsVisivel: valorIcms.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
    }));
  };

  const calculaVendasArbitradas = () => {
    let valorVendas = "";

    if (values.pcVendas !== undefined && values.vlCMV !== undefined) {
      valorVendas = values.vlCMV + (values.vlCMV * values.pcVendas) / 100;
    }

    setValues((curr) => ({
      ...curr,
      vlVendasArbitradas: valorVendas,
    }));
  };

  const calculaOmissaoVendas = () => {
    let valorOmissao = "";

    if (values.vlVendasArbitradas !== undefined && values.vlVendasDeclaradas !== undefined) {
      valorOmissao = values.vlVendasArbitradas - values.vlVendasDeclaradas;
    }

    setValues((curr) => ({
      ...curr,
      vlOmissaoSaidas: valorOmissao,
    }));
  };

  const calculaIcmsGeral = () => {
    let valorIcms = "";

    if (values.vlBaseCalculo !== undefined && values.pcIcmsAuditor !== undefined && values.vlCredito !== undefined) {
      valorIcms = (values.vlBaseCalculo * values.pcIcmsAuditor) / 100 - values.vlCredito;
    }

    setValues((curr) => ({
      ...curr,
      vlIcms: valorIcms,
    }));
  };

  const calculaIcmsR = () => {
    let valorIcms = "";

    if (values.vlBaseCalculo !== undefined && values.pcIcmsAuditor !== undefined) {
      valorIcms = (values.vlBaseCalculo * values.pcIcmsAuditor) / 100;
    }

    setValues((curr) => ({
      ...curr,
      vlIcms: valorIcms,
    }));
  };

  const calculaDataVencimento = (e) => {
    const inputDate = new Date(`${values[e.target.name]}T00:00:00Z`); // Força UTC
    if (Number.isNaN(inputDate.getTime())) return; // Evita erro se a data for inválida

    // Criar uma nova data baseada na original
    const nextDate = new Date(inputDate);
    nextDate.setUTCMonth(nextDate.getUTCMonth() + 1); // Adicionar um mês
    nextDate.setUTCDate(15); // Fixar o dia para 15

    setValues((curr) => ({
      ...curr,
      dtVencimento: nextDate.toISOString().split("T")[0], // Formato YYYY-MM-DD
    }));
  };

  const calculaBaseCalculo = () => {
    let valorBaseCalculo = "";

    if (values.valorTotalNota !== undefined && values.pcAgregadoAuditor !== undefined) {
      valorBaseCalculo = values.valorTotalNota + (values.valorTotalNota * values.pcAgregadoAuditor) / 100;
    }

    setValues((curr) => ({
      ...curr,
      vlBaseCalculo: valorBaseCalculo,
    }));
  };

  const calculaBaseCalculoR = () => {
    let valorBaseCalculo = "";

    if (values.vlArrolamento !== undefined && values.pcAgregadoAuditor !== undefined) {
      valorBaseCalculo = values.vlArrolamento + (values.vlArrolamento * values.pcAgregadoAuditor) / 100;
    }

    setValues((curr) => ({
      ...curr,
      vlBaseCalculo: valorBaseCalculo,
    }));
  };

  const calculaIcmsDet = (tipoDetalhamento) => {
    let vlIcms = "";

    if (values.vlIcmsCalculado !== undefined && values.vlIcmsRecolhido !== undefined && tipoDetalhamento !== null) {
      if (tipoDetalhamento === "AI") {
        vlIcms = values.vlIcmsCalculado - values.vlIcmsRecolhido;
      } else if (tipoDetalhamento === "AM") {
        vlIcms = values.vlIcmsRecolhido - values.vlIcmsCalculado;
      }
    }

    if (tipoDetalhamento === "Q") {
      console.log(tipoDetalhamento);
      if (values.vlDeclarado !== null && values.vlApurado !== null) {
        vlIcms = values.vlDeclarado - values.vlApurado;
      }
    }

    setValues((curr) => ({
      ...curr,
      vlIcms,
    }));
  };

  const handleDataChange = (event) => {
    setFieldValue(event.target.id, event.target.value);
  };

  const handleMoneyChange = (event) => {
    setFieldValue(event.target.id, event.target.value.replace(/[^0-9]/g, "") / 100);
  };

  return {
    calculaData,
    calculaIcms,
    handleDataChange,
    handleMoneyChange,
    calculaVendasArbitradas,
    calculaOmissaoVendas,
    calculaIcmsGeral,
    calculaIcmsR,
    calculaDataVencimento,
    calculaBaseCalculo,
    calculaBaseCalculoR,
    calculaIcmsDet,
  };
};

export default useAcoesDemonstrativo;
